import { tv } from 'tailwind-variants'

import { COLOR } from '@ui-kit/constants/index'
import { body2, caption } from '@ui-kit/core/typography'

export const selectionButton = tv({
  slots: {
    container:
      'flex w-full cursor-pointer flex-row items-center gap-x-4 rounded-[8px] bg-grey-100 px-5 py-5 hover:opacity-70 active:opacity-70',
    textContainer: 'flex flex-1 flex-col items-start justify-center gap-y-1',
    title: body2({ align: 'left', emphasis: 'default' }),
    subtitle: caption({ align: 'left', emphasis: 'medium', color: COLOR.grey500 }),
  },
  variants: {
    type: {
      radio: {},
      checkbox: {},
      noaid: {},
    },
    disabled: {
      true: {
        container: 'cursor-default opacity-40',
        title: body2({ align: 'left', emphasis: 'low' }),
        subtitle: caption({ align: 'left', emphasis: 'low' }),
      },
    },
    selected: {
      true: {},
    },
    hasError: {
      true: {
        container: 'border-2 border-error',
        subtitle: caption({ align: 'left', emphasis: 'medium', color: 'error' }),
      },
    },
    noOutline: {
      true: {},
    },
    size: {
      large: {
        container: 'px-5 py-6',
      },
      default: {},
      compact: {
        container: 'min-w-[72px] flex-1 justify-center px-4 py-5',
        textContainer: 'flex-none items-center',
      },
    },
    variant: {
      outlined: {
        container: 'rounded-lg border border-grey-300 bg-white',
      },
      filled: {},
    },
  },
  compoundVariants: [
    {
      variant: 'outlined',
      selected: true,
      className: {
        container: 'border-2 border-black',
      },
    },
    {
      variant: 'filled',
      selected: true,
      className: {
        container: 'bg-black',
        title: 'text-white',
        subtitle: 'text-white',
      },
    },
    {
      hasError: true,
      noOutline: true,
      className: {
        title: 'text-error',
        subtitle: 'text-error',
      },
    },
  ],
})
